import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/refund")({
  head: () => ({
    meta: [
      { title: "Refund Policy · Buddha KA" },
      { name: "description", content: "Refund and return policy for Buddha KA music, books, memberships, and shop items." },
      { property: "og:title", content: "Refund Policy · Buddha KA" },
      { property: "og:description", content: "How refunds work for Buddha KA and KAfrequency purchases." },
      { property: "og:url", content: "https://buddhaka.com/refund" },
    ],
    links: [{ rel: "canonical", href: "https://buddhaka.com/refund" }],
  }),
  component: RefundPage,
});

function RefundPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24">
      <p className="text-xs uppercase tracking-[0.3em] text-gold">Legal</p>
      <h1 className="mt-4 font-serif text-5xl">Refund Policy</h1>
      <p className="mt-3 text-xs text-muted-foreground">Last updated: July 15, 2026</p>

      <div className="mt-10 space-y-6 text-sm leading-relaxed text-muted-foreground">
        <h2 className="font-serif text-2xl text-foreground">Digital products</h2>
        <p>Music, books, meditations, and other downloads are non-refundable once delivered — this is standard for digital content. If you experienced a technical issue that prevented download, email us within 14 days at <a className="text-gold underline" href="mailto:support@buddhaka.com">support@buddhaka.com</a> and we will make it right.</p>

        <h2 className="font-serif text-2xl text-foreground">Physical products</h2>
        <p>Physical items (apparel, artifacts) can be returned within 14 days of delivery if unused and in original condition. Buyer pays return shipping. Refunds are issued to the original payment method within 5-10 business days of receiving the return. Custom-made or personalized items are not returnable.</p>

        <h2 className="font-serif text-2xl text-foreground">Memberships</h2>
        <p>Monthly memberships can be canceled at any time and access continues through the end of the paid period. We do not pro-rate mid-period cancellations. If you were charged after canceling, contact us within 7 days for a full refund.</p>

        <h2 className="font-serif text-2xl text-foreground">Lifetime Ascension Pass</h2>
        <p>The Lifetime Ascension Pass is refundable within 14 days of purchase, provided you have not downloaded exclusive lifetime-only content. After 14 days it is non-refundable.</p>

        <h2 className="font-serif text-2xl text-foreground">Chargebacks and duplicate charges</h2>
        <p>If you see a duplicate or unrecognized charge, email us first — we resolve most cases within one business day, faster than a bank dispute.</p>

        <h2 className="font-serif text-2xl text-foreground">Contact</h2>
        <p><a className="text-gold underline" href="mailto:support@buddhaka.com">support@buddhaka.com</a></p>
      </div>
    </div>
  );
}
